import { ComputedAttributes } from './../../Units/Components/computedAttributes'
export default ComputedAttributes
